import { NOT_LOGGED_MODAL, SEND_GRADE_ERROR_MODAL, THEORIES_MODAL } from '../containers/modal/modal-types';

export const HIDE_MODAL = 'HIDE_MODAL';
export const HIDE_NOT_LOGGED_MODAL = 'HIDE_NOT_LOGGED_MODAL';
export const HIDE_REPORT = 'HIDE_REPORT';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_NOT_LOGGED_MODAL = 'SHOW_NOT_LOGGED_MODAL';
export const SHOW_SEND_GRADE_ERROR_MODAL = 'SHOW_SEND_GRADE_ERROR_MODAL';
export const SHOW_REPORT = 'SHOW_REPORT';
export const SHOW_THEORIES_MODAL = 'SHOW_THEORIES_MODAL';
export const SHOW_OPEN_ASSIGNMENT_MODAL = 'SHOW_OPEN_ASSIGNMENT_MODAL';

export const showNotLoggedModal = () => {
    return (dispatch) => {
        dispatch({ type: SHOW_MODAL, payload: NOT_LOGGED_MODAL });
        dispatch({ type: SHOW_NOT_LOGGED_MODAL });
    };
};

export const hideNotLoggedModal = () => {
    return {
        type: HIDE_NOT_LOGGED_MODAL,
    };
};

export const showModal = (type) => {
    return {
        type: SHOW_MODAL,
        payload: type,
    };
};

export const hideModal = () => {
    return {
        type: HIDE_MODAL,
    };
};

export const showReport = () => {
    return {
        type: SHOW_REPORT,
    };
};

export const hideReport = () => {
    return {
        type: HIDE_REPORT,
    };
};

export const showSendGradeErrorModal = () => {
    return (dispatch) => {
        dispatch({ type: SHOW_MODAL, payload: SEND_GRADE_ERROR_MODAL });
        dispatch({ type: SHOW_SEND_GRADE_ERROR_MODAL });
    };
};

export const showTheoriesModal = (theoryGroupId, theme, microTheme, theories) => {
    return (dispatch) => {
        dispatch({ type: SHOW_THEORIES_MODAL, payload: { theoryGroupId, theme, microTheme, theories } });
        dispatch({ type: SHOW_MODAL, payload: THEORIES_MODAL });
    };
};

export const showOpenAssignmentModal = (assignmentUniqueCode) => ({
    type: SHOW_OPEN_ASSIGNMENT_MODAL,
    payload: assignmentUniqueCode,
});
